import { useCallback } from 'react'
import ApiService from '../../services/ApiService'

const InteractorCustomerList = () => {
  const customerList = useCallback((body, callback) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/account-user/list', payload, response => {
      if (response.status_code === 200) {
        callback(response.data)
      }
    })
  }, [])

  return { customerList }
}

export default InteractorCustomerList
